import { requiredOptionMessage } from "../validationMessages";

import { trimmedString } from "./trimmedString";

export const insuranceCompanyValidator = trimmedString;
export const insuranceCompanyValidatorRequired = trimmedString.required(
  requiredOptionMessage
);
